import { Close } from "@mui/icons-material";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import { useState } from "react";

const AlphabetHeader = ({ rows, onLetterClick }) => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const [selectedLetter, setSelectedLetter] = useState('');

    const handleLetterClick = (letter) => {
        if (selectedLetter != letter) {
            setSelectedLetter(letter);
            // Filtrar los registros por nombre que comienza con la letra seleccionada
            const filteredRows = rows.filter((row) =>
                row.nombre.toUpperCase().startsWith(letter)
            );
            onLetterClick(filteredRows);
        } else {
            setSelectedLetter('');
            onLetterClick(rows);
        }
    };

    const handleClear = () => {
        setSelectedLetter("");
        onLetterClick(rows);
    }

    return (
        <Paper variant='outlined' sx={{ display: 'flex' }}>
            <Box sx={{ mx: 2, display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%' }}>
                {alphabet.split('').map((letter, index) => (
                    <Typography
                        key={index}
                        sx={{
                            cursor: 'pointer',
                            mr: 2,
                            fontWeight: selectedLetter === letter ? 'bold' : 'normal',
                            textDecoration: selectedLetter === letter ? 'underline' : 'none',
                        }}
                        onClick={() => handleLetterClick(letter)}
                    >
                        {letter}
                    </Typography>
                ))}
                <IconButton
                    size="small"
                    key="clear"
                    style={{
                        cursor: 'pointer',
                    }}
                    color="danger"
                    sx={{ bgcolor: '#faaaaa', '&:hover': { bgcolor: '#e0a0a0' } }}
                    onClick={handleClear}
                >
                    <Close color="error" />
                </IconButton>
            </Box>
        </Paper>
    );
};

export default AlphabetHeader;